// Copyright (C) 2021 TANNER AG

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import classNames from "classnames";
import Heading4 from "../styleguide/Heading4";
import Paragraph from "../styleguide/Paragraph";
import { Link } from "react-router-dom";
import { ArrowRight } from "../components/Icons";
import buildAssetUrl from "../utils/buildAssetUrl";

const styles = (theme) => ({
    container: {
        paddingTop: 20,
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
    },
    root: {
        backgroundColor: "#fff",
        display: "flex",
    },
    imageSection: {
        width: 200,
        display: "flex",
        flexShrink: 0,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    image: {
        maxWidth: "100%",
        height: "auto",
    },
    heading: {
        textTransform: "uppercase",
        fontWeight: "bold",
        fontFamily: "MANEurope, Arial, sans-serif",
        fontSize: 20,
        marginBottom: 12,
    },
    number: {
        color: "#e40045",
        marginRight: 8,
    },
    content: {
        padding: 16,
    },
    link: {
        textDecoration: "none",
        color: "#303C49",
        marginTop: 16,
        display: "block",
    },
});

const EMobilityChapterCard = ({ title, intro, to, image, number, classes, actionLabel }) => {
    let imageUrl;
    if (image) {
        const { url } = buildAssetUrl(image, image.width);
        imageUrl = url;
    }

    return (
        <Grid container spacing={0} className={classNames(classes.container)}>
            <Grid item xs md={8}>
                <div className={classes.root}>
                    <div className={classes.imageSection} style={{ backgroundImage: `url(${imageUrl})` }} />
                    <div className={classes.content}>
                        <Heading4 className={classes.heading}>
                            <span className={classes.number}>{number}</span>
                            <span>{title}</span>
                        </Heading4>
                        <Paragraph>{intro}</Paragraph>
                        <Link to={to} className={classes.link}>
                            <ArrowRight size={12} style={{ color: "#e40045", marginRight: 8 }} />
                            <span>{actionLabel}</span>
                        </Link>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(EMobilityChapterCard);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityChapterCard.js